import { withInstall, withNoopInstall } from '@bigin/utils'
import Form from './src/form.vue'
import FormItem from './src/form-item.vue'
import DataValue from './src/data-value.vue'

export const BForm = withInstall(Form, {
  FormItem,
  DataValue,
})
export default BForm
export const BFormItem = withNoopInstall(FormItem)
export const BDataValue = withNoopInstall(DataValue)

export * from './src/form-item'
export * from './src/types'

export type FormInstance = InstanceType<typeof Form>
export type FormItemInstance = InstanceType<typeof FormItem>
export type DataValueInstance = InstanceType<typeof DataValue>
